// extracted by mini-css-extract-plugin
export default {"root":"AppContainer_root__ni3Qi"};